import { recordingTypeOptions } from 'constants/feeTypes';

export const getInitialFormValues = ({
  recordingFees,
  feesOptions,
  transferTaxes,
  feeProviderOptions,
  cureBaseline,
}) => ({
  recordingFees: recordingFees.map((fee, index) => {
    const formattedFee = {
      ...fee,
      index,
      feeTypeName: fee.feeName,
      feeTypeId: feesOptions.find(i => i.value === fee.feeTypeId),
      recordingType: recordingTypeOptions.find(i => i.value === fee.recordingType),
    };

    return {
      ...formattedFee,
      initialFee: formattedFee,
      cureBaseline: cureBaseline?.[fee.feeTypeId],
    };
  }),
  transferTaxes: transferTaxes.map((fee, index) => {
    const formattedFee = {
      ...fee,
      index,
      feeTypeName: fee.feeName,
      feeTypeId: feesOptions.find(i => i.value === fee.feeTypeId),
      feeProviderId: feeProviderOptions.find(i => i.value === fee.feeProviderId),
    };

    return {
      ...formattedFee,
      initialFee: formattedFee,
      cureBaseline: cureBaseline?.[fee.feeTypeId],
    };
  }),
});
